import { ElementType } from 'react';
import useResponsive, { QUERIES } from '@creditflowresearch/uilib/hooks/useResponsive';
import DataTable from '@creditflowresearch/uilib/Table/DataTable';
import DealMobileCard from '@/creditflowresearch/ui/components/deals/DealListTable/components/DealMobileCard';
import { ICorporateDeal } from '@/creditflowresearch/domain/vo/Deals/CorporateDeal';
import type { IColumn } from '@creditflowresearch/uilib/Table/DataTable';

export interface ICorporateDataTableProps {
  columns: IColumn[],
  data: ICorporateDeal[],
  className: string,
  isFetching: boolean,
  dataTest: string,
  loadingComponent: ElementType,
}

export const CorporateDataTable = (props: ICorporateDataTableProps) => {
  const isMobile = useResponsive(QUERIES.MOBILE);

  return isMobile ? <DealMobileCard { ...props } /> : <DataTable { ...props } />;
};
